import React, { useEffect, useState } from 'react';

import { PrivacyWall } from '@fec/frontend/modules/content/embed/PrivacyWall';
import { ACTIVATE_CMP_CATEGORY } from '@fec/assets/js/utils/event';
import { hasCategoryConsent } from '@aron/common/consent/consentManager.js';

import './embed.scss';
import classNames from 'classnames';

export const PrivacyShield = ({
  children,
  styleModifier = null,
  contentStyleModifier = null,
  excludeFromCmp = false,
}) => {
  const [hasConsent, setConsent] = useState(
    excludeFromCmp ? true : hasCategoryConsent('functional'),
  );
  const handleCmpDecision = (event) => {
    if (event.detail.category === 'functional') {
      setConsent(true);
    }
  };

  // react on changes from CMP overlay
  useEffect(() => {
    if (!excludeFromCmp) {
      window.addEventListener(ACTIVATE_CMP_CATEGORY, handleCmpDecision);
    }

    return () => {
      window.removeEventListener(ACTIVATE_CMP_CATEGORY, handleCmpDecision);
    };
  }, [handleCmpDecision, excludeFromCmp]);

  return (
    <div className={classNames('embed', styleModifier)}>
      {hasConsent && (
        <div className={classNames('embed__content', contentStyleModifier)}>
          {children}
        </div>
      )}
      {!hasConsent && (
        <PrivacyWall onAccept={() => setConsent(true)}></PrivacyWall>
      )}
    </div>
  );
};
